// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 343 ? "6edf0643" : chunkId) + "." + {"343":"d8a7c6b6bdcdfe66","1263":"a7e3276cc19d1470","6967":"2859eb729a89be0d"}[chunkId] + ".js";
};